import React, { useEffect, useState } from 'react';
import './ProfileForm.css';
import VehicleTow from './../Multiple/VehicleTow';
import VehicleNotMatch from './VehicleNotMatch';
import DropdownSelect from './../Customer/Select2DropDown';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCities, fetchStates } from '../../store/reducers/cityStateReducer';
import { OtpAuthenticate } from '../../store/reducers/otpReducer';
import { setRenewalData } from '../../store/reducers/myPlansReducer';
import { verifyRegisterNumber, checkCustomer, } from '../../store/reducers/profileReducer';
import { setFromSummaryPage } from '../../store/reducers/flowStepReducer';
import Spinner from './../Spinner';
import { useNavigate } from 'react-router-dom';
import { fetchPlanDetails } from '../../store/reducers/priceReducer';
import { isEncrypted } from './../../utils/Common.js';
import { PDF_URL } from '../../utils/Constants';
import { handleDownload} from '../../utils/Common.js';


export const ProfileForm = ({ profile, onSubmit, renewalData }) => {

  console.log("ProfileFormprofile",profile);
  const renewalVehicleTypeId = profile?.profileData?.data?.vehicle_type_id || 0;
  console.log("renewalVehicleTypeId",renewalVehicleTypeId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { states, cities } = useSelector((state) => state.cityStateList);
  const profileResponse = useSelector((state) => state.profileList);
  const priceData = useSelector(state => state.priceList.apiResponse.data || []);
  const loader = useSelector(state => state.profileList?.loading);
  const profileLoader = useSelector(state => state.profileList?.profileLoader);
  const { loading, apiResponse } = useSelector((state) => state.OtpAuthenticateList);
  const { vehicleNumberloading } = useSelector((state) => state.profileList?.vehicleRegLoader);
  const { fromSummaryPage } = useSelector((state) => state.flowStepList);
  const vehicleData = profileResponse.vehicleData || {};
  console.log("renewalData2222",renewalData);
  console.log("isFromSummaryPage",fromSummaryPage);
  console.log("priceDatapriceData",priceData);
  console.log("profileResponse",profileResponse);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [showVehicleMismatch, setShowVehicleMismatch] = useState(false);
  const [overrideVehicleTypeId, setOverrideVehicleTypeId] = useState(null);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);


  // const [loading, setLoading] = useState(false);
const [formDisabled, setFormDisabled] = useState(false);
const [vehicleMatch, setVehicleMatch] = useState(true);
const [focusedField, setFocusedField] = useState(null);

const {web} = isEncrypted(JSON.parse(localStorage.getItem('mblnbr')));
console.log("webwebweb1222",web);

  useEffect(() => {
    dispatch(fetchCities());
    dispatch(fetchStates());
    
  }, []);

  // useEffect(() => {
  //   const users = profile?.profileData?.data || {};
  //   const planName = priceData?.plan_name ?? '';
  //   const vehicleType = priceData?.vehicle_type?.vehicle_type_code ?? '';
  
  //   if (users?.user_id || users?.gb_chola_id || planName) {
  //      setFormData(users);
  //     setFormData(prev => ({
  //       ...prev,
  //       user_id: users.user_id ?? '',
  //       gb_chola_id: users.gb_chola_id ?? '',
  //       plan_name: planName,
  //       vehicle_type: vehicleType
  //     }));

  //   }
  //   const existingProfile = JSON.parse(localStorage.getItem('customerProfile'));
  //   if (existingProfile) {
  //     setFormData(existingProfile);
  //   }
  //   console.log("usersusersusersusers",users);
  // }, [dispatch, profile]);

  useEffect(() => {
    if (!isFormTouched) {
        const users = profile?.profileData?.data || {};
        const planName = priceData?.plan_name ?? '';
        const vehicleType = priceData?.vehicle_type?.vehicle_type_code ?? '';
      
        if (users?.user_id || users?.gb_chola_id || planName) {
          setFormData(users);
          setFormData(prev =>({
            ...prev,
            user_id: users.user_id ?? '',
            gb_chola_id: users.gb_chola_id ?? '',
            plan_name: planName,
            vehicle_type: vehicleType
          }));
        }
          const existingProfile = JSON.parse(localStorage.getItem('customerProfile'));
          if (existingProfile) {
            console.log("typeof existingProfile", existingProfile);
            // setFormData(prev => ({ ...prev, ...existingProfile }));
            setFormData(prev => ({ ...prev}));
          }
          
        // if (existingProfile) {
        //   setFormData(existingProfile);
        // }
      
        
      
        // Prefill state based on city_id from profile
        const cityId = users?.city;
        if (cityId && cities.length > 0) {
          const selectedCity = cities.find((c) => c.city_id === cityId);
          if (selectedCity) {
            dispatch(fetchStates(selectedCity.state_id)).then((res) => {
              const stateData = res.payload;
      
              const statesArray = Array.isArray(stateData)
                ? stateData
                : stateData && typeof stateData === 'object'
                ? [stateData]
                : [];
      
              const matchedState = statesArray.find(
                (s) => s.state_id === selectedCity.state_id
              );
      
              if (matchedState) {
                setFormData((prev) => ({
                  ...prev,
                  state: matchedState.state_id,
                }));
              }
            });
          }
        }
        console.log("usersusersusersusers", users);
    }
    
    if (fromSummaryPage && profile?.formData) {
      setFormData(profile.formData);
      console.log("isFromSummaryPage222", fromSummaryPage);
    }

    
  }, [dispatch, profile, cities, isFormTouched, fromSummaryPage]);
  
  
  
console.log("profileprofileprofile",profile);

  const handleChange = (e) => {
      const { name, value } = e.target;
      setIsFormTouched(true); // Mark form as touched

      let updatedValue = value;

      if (name === 'mobile') {
        // Remove non-digit characters
        updatedValue = value.replace(/\D/g, '');

        // Prevent starting with 0
        if (updatedValue.startsWith('0')) {
          updatedValue = updatedValue.slice(1);
        }

        // Limit to 10 digits
        updatedValue = updatedValue.slice(0, 10);
      }


      // if (name === 'reg_no') {
      //   updatedValue = updatedValue.toUpperCase();
      // }

      if (name === 'reg_no') {
        if (!/^[A-Za-z0-9]*$/.test(value)) return; // block invalid characters
        // updatedValue = updatedValue.toUpperCase();
      }


      if (name === 'pincode') {
        // Remove non-digit characters
        updatedValue = value.replace(/\D/g, '');
    
        // Prevent starting with 0
        if (updatedValue.startsWith('0')) {
          updatedValue = updatedValue.slice(1);
        }
    
        // Limit to 6 digits
        updatedValue = updatedValue.slice(0, 6);
      }

      setFormData((prev) => ({ ...prev, [name]: updatedValue }));

      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
  };

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  
    if (name === 'city') {

      if (!value) {
        // City cleared — also clear state
        setFormData((prev) => ({ ...prev, state: '' }));
        return;
      }

      const selectedCity = cities.find((c) => c.city_id === value);
      if (selectedCity) {
        dispatch(fetchStates(selectedCity.state_id)).then((res) => {
          const stateData = res.payload;
  
          // Normalize to array
          const statesArray = Array.isArray(stateData)
            ? stateData
            : stateData && typeof stateData === 'object'
            ? [stateData]
            : [];
  
          const matchedState = statesArray.find(
            (s) => s.state_id === selectedCity.state_id
          );
  
          if (matchedState) {
            setFormData((prev) => ({
              ...prev,
              state: matchedState.state_id,
            }));
          }
        });
      }
    }
  
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };


  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
  
    setFormData((prev) => ({ ...prev, [name]: checked }));
  
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  
  };

  const toTitleCaseWithSpace = (str) => {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const mobileRegex = /^[6-9][0-9]{9}$/; // Starts with 6-9, followed by 9 digits

  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  // const nameRegex = /^[A-Za-z\s]*$/;
  const nameRegex = /^[A-Za-z\s]+$/;


  // const pincodeRegex = /^[1-9][0-9]{5}*$/; // Indian Pincode Regex
  const pincodeRegex = /^[0-9]*$/; 


  // const handleDownload = () => {
  //   // const fileUrl = '/assets/pdf/RSA_Terms_Conditions.pdf';
  //   // const link = document.createElement('a');
  //   // link.href = fileUrl;
  //   // link.download = 'Terms-and-Conditions.pdf';
  //   // document.body.appendChild(link);
  //   // link.click();
  //   // document.body.removeChild(link);
  // };

 
  const validate = () => {
    const requiredFields = [
      'first_name', 'last_name', 'email', 'mobile',
      'reg_no', 'address_1', 'city', 'state', 'pincode',
      'tandc'
    ];
  
    const newErrors = {};
    let firstInvalidField = null;
  
    requiredFields.forEach((field) => {
      console.log("formDataformDataforEach",formData);
      const value = formData[field];
      
      if (!formData[field]) {
        const readableField = toTitleCaseWithSpace(field);
        newErrors[field] = `${readableField} is required`;
        if (!firstInvalidField) firstInvalidField = field;

        if (!formData.tandc) {
          newErrors.tandc = 'You must accept the Terms & Conditions';
          if (!firstInvalidField) firstInvalidField = 'tandc';
        }
      }else{
        // Additional validations
        if (field === 'mobile' && !mobileRegex.test(value)) {
          newErrors[field] = 'Mobile number must be 10 digits and not start with 0-5';
          if (!firstInvalidField) firstInvalidField = field;
        }
        if (field === 'email' && !emailRegex.test(value)) {
          newErrors[field] = 'Invalid email format';
          if (!firstInvalidField) firstInvalidField = field;
        }
        if (field === 'pincode' && !pincodeRegex.test(value)) {

          // Allow only digits
          if (!/^\d*$/.test(value)) return;

          // Max 6 digits
          if (value.length > 6) return;

          // Don't allow starting with 0
          if (value.length === 1 && value === '0') return;

          newErrors[field] = 'Invalid pincode';
          if (!firstInvalidField) firstInvalidField = field;
        }
        if (field == 'first_name' && !nameRegex.test(value)) {
          newErrors[field] = 'Invalid First Name';
          if (!firstInvalidField) firstInvalidField = field;
        }
        if (field == 'last_name' && !nameRegex.test(value)) {
          newErrors[field] = 'Invalid Last Name';
          if (!firstInvalidField) firstInvalidField = field;
        }
      }
    });
  
    setErrors(newErrors);
  
    if (firstInvalidField) {
      const el = document.getElementsByName(firstInvalidField)[0];
      if (el) {
        el.focus();
        setFocusedField(firstInvalidField);
      }
    }

    return Object.keys(newErrors).length === 0;
  };
  


  const validateRegNo = (regNo) => {
    const vehicleRegRegex = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/i;
    return vehicleRegRegex.test(regNo);
  };

  const handleAcceptMismatch = () => {
    // setFormData((prev) => ({
    //   ...prev,
    //   vehicle_type_id: overrideVehicleTypeId,
    // }));
    setShowVehicleMismatch(false);
    setVehicleMatch(true);
    dispatch(fetchPlanDetails(localStorage.getItem('vTypeId')));
    if (errors['reg_no']) {
      setErrors((prev) => ({ ...prev, ['reg_no']: '' }));
    }
    // setErrors({ reg_no: verifyResponse?.message || 'Vehicle registration number not found.'});
    // handleSubmit(); // Retry submission with updated type
  };
  
  const handleDeclineMismatch = () => {
    navigate('/', { state: { scrollToVehicleSection: true } }); // Or your route to plan screen
  };

  const handleSubmit = async() => {

    if (!validate()) return;


    let regNo = formData.reg_no?.trim().toUpperCase();

    if (!validateRegNo(regNo)) {
      setErrors({ reg_no: 'Invalid vehicle registration number format.' });
      const el = document.getElementsByName('reg_no')[0];
      if (el) el.focus();

      return;
    }

    try{
      setFormDisabled(true); // Disable form
      setSubmitLoading(true);
      let profileMobile = profile?.profileData?.data?.mobile ?? '';
      let checkCustomerResponse;
      if(profileResponse.isNewCustomer){
        let mobileNo = profileMobile || formData.mobile;
        let verifiedData = isEncrypted(mobileNo);
        checkCustomerResponse = await dispatch(checkCustomer(verifiedData)).unwrap();
        console.log("responsehandleFormSubmit",checkCustomerResponse);
      }
        // let requestVehicle = { reg_no: regNo,vehicle_type_id:priceData?.vehicle_type?.vehicle_type_id ?? ''};
        let requestVehicle = {
          reg_no: regNo,
          // vehicle_type_id: renewalVehicleTypeId ??? overrideVehicleTypeId ?? (priceData?.vehicle_type?.vehicle_type_id ?? '')
          vehicle_type_id: renewalVehicleTypeId || overrideVehicleTypeId || priceData?.vehicle_type?.vehicle_type_id || ''
        };
        
        const verifyResponse = await dispatch(verifyRegisterNumber(requestVehicle)).unwrap();

        if (verifyResponse?.success !== true && verifyResponse?.vehicle_type_id > 0) {
          setErrors({ reg_no: verifyResponse?.message });
          setVehicleMatch(false);
          setOverrideVehicleTypeId(verifyResponse?.vehicle_type_id); // Save new type
          localStorage.setItem('vTypeId',JSON.stringify(verifyResponse?.vehicle_type_id || 1));
          setFormDisabled(false); // Re-enable form on failure
          setSubmitLoading(false);
          return;
        }else if(verifyResponse?.success !== true){
          setErrors({ reg_no: verifyResponse?.message || 'Vehicle registration number not found.'});
          setFormDisabled(false);
          setSubmitLoading(false);
          return;
        }
        const localFormData = {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          mobile: profileMobile || formData.mobile, // profile?.profileData?.data?.mobile ?? '', //formData.mobile,
          reg_no: formData.reg_no.toUpperCase(),
          address_1: formData.address_1,
          address_2: formData.address_2,
          city: formData?.city, 
          state: formData?.state,
          pincode: formData.pincode,
          user_id: formData.user_id || checkCustomerResponse?.data?.user_id,
          gb_chola_id: formData.gb_chola_id || checkCustomerResponse?.data?.gb_chola_id,
          // plan_name: priceData?.plan_name ?? profile?.profileData?.data?.plan_name || '',
          // vehicle_type: priceData?.vehicle_type?.vehicle_type_code ?? profile?.profileData?.data?.vehicle_type || '',
          plan_name: (priceData?.plan_name ?? profile?.profileData?.data?.plan_name) || '',
          vehicle_type: (priceData?.vehicle_type?.vehicle_type_code ?? profile?.profileData?.data?.vehicle_type) || '',
          //fuel_type: formData.fuel_type
        };
        console.log('localFormData:', localFormData);
          localStorage.setItem('customerProfile', JSON.stringify(localFormData));
          localStorage.setItem('reg_no', JSON.stringify(localFormData.reg_no));

          if(!JSON.parse(localStorage.getItem('mblnbr'))){
            localStorage.setItem('mblnbr', JSON.stringify(localFormData.mobile));
          }

          if(!JSON.parse(localStorage.getItem('vTypeId')) && renewalVehicleTypeId > 0){
            localStorage.setItem('vTypeId', JSON.stringify(renewalVehicleTypeId));
          }

          if(profileResponse.isNewCustomer){
            const authData = {mobile_number:formData.mobile,validate_user:false};
            const otpResponse = await dispatch(OtpAuthenticate(authData)).unwrap();
            console.log('OTP triggered successfully:', otpResponse);
          }

          // dispatch(setFromSummaryPage(true)); // reset the from summary page state.

        if (onSubmit) onSubmit(localFormData); // Optional callback

    }catch (error) {
        console.error('Error during submission:', error);
        alert('Something went wrong. Please try again.');
        setFormDisabled(false); // Re-enable form on error
        setSubmitLoading(false);
    } finally {
        // setLoading(false);
    }
  }
    
  console.log("formdataformData",formData);
  // {profileLoader && <Spinner />}

{formDisabled && (
  <div className="form-overlay">
    <div className="spinner"></div>
  </div>
)}

console.log("submitLoading",submitLoading);
  return (
    <div className='profile-details'>
      <VehicleTow 
        paragraphText="We understand that vehicle breakdown can be stressful and unpredictable. That’s why our world-class roadside assistance services are designed to alleviate your worries and restore your peace of mind."
        paragraphText2="From flat tyres and dead batteries to emergency towing and lockouts, our trained professionals are available 24/7 to get you back on the road quickly and safely. We ensure that help is always within reach." 
        headerText="Your safety and peace of mind are our top priorities, wherever the road takes you"
      />
      <div className='form-tile'>
        <h3 className='light'>All we need are a few details to</h3>
        <h3 className='bold'>Help you in times of your need!</h3>
      </div>

      <form className="customer-form" noValidate>
        <h3 className='info'>Customer Information</h3>

        {formData.reg_no ? 
          <label>Vehicle Registration Number</label> 
        :''
        }
        <input 
           name="reg_no" 
           placeholder="Vehicle Registration Number*" 
           value={formData.reg_no || ''} 
           onChange={handleChange} 
           disabled={formDisabled}
           className={errors.reg_no ? 'focusedColumn' : ''}
        />
        
        {errors.reg_no && <span className="error-text">{errors.reg_no}</span>}

        {!vehicleMatch &&
          <VehicleNotMatch 
            onAccept={handleAcceptMismatch}
            onDecline={handleDeclineMismatch}
            message={vehicleData}
          />
        }

        {formData.first_name ? 
          <label>First Name</label> 
        :''
        }
        <input 
          name="first_name" 
          placeholder="First Name*" 
          value={formData.first_name === 'rsacustomer' ? '' : formData.first_name || ''} 
          // value={formData.first_name === 'rsacustomer' || ''} 
          onChange={handleChange} 
          className={errors.first_name ? 'focusedColumn' : ''}

          />
        {errors.first_name && <span className="error-text">{errors.first_name}</span>}

        {formData.last_name ? 
          <label>Last Name</label> 
        :''
        }
        <input 
          name="last_name"
          placeholder="Last Name*" 
          value={formData.last_name || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
          className={errors.last_name ? 'focusedColumn' : ''}
        />
        {errors.last_name && <span className="error-text">{errors.last_name}</span>}

        {formData.email ? 
          <label>Email ID</label> 
        :''
        }
        <input 
          name="email" 
          placeholder="Email ID*" 
          value={formData.email || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
        />
        {errors.email && <span className="error-text">{errors.email}</span>}

        {formData.mobile ? 
          <label>Mobile Number</label> 
        :''
        }
        <input 
          name="mobile" 
          placeholder="Mobile Number*" 
          value={formData.mobile || ''} 
          onChange={handleChange} 
          required
          disabled={web === false}
          onPaste={(e) => {
            const pasted = e.clipboardData.getData('Text');
            if (!/^[1-9][0-9]{0,9}$/.test(pasted)) {
              e.preventDefault();
            }
          }}
          className={errors.mobile ? 'focusedColumn' : ''}
        />
        {errors.mobile && <span className="error-text">{errors.mobile}</span>}
        {loader && <Spinner />}

        {/* {formData.fuel_type ? 
          <label>Fuel Type</label> 
        :''
        }
        <select 
           name="fuel_type" 
           value={formData?.fuel_type || ''} 
           onChange={handleChange} 
           required
           disabled={formDisabled}
           className={errors.fuel_type ? 'focusedColumn' : ''}
        >
          <option value="">Select Fuel Type*</option>
          <option value="EV">EV</option>
          <option value="Non EV">Non EV</option>
        </select>
        {errors.fuel_type && <span className="error-text">{errors.fuel_type}</span>} */}

        {formData.address_1 ? 
          <label>Address</label> 
        :''
        }
        <input 
          name="address_1" 
          placeholder="Address*" 
          value={formData.address_1 || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
          className={errors.address_1 ? 'focusedColumn' : ''}
        />
        {errors.address_1 && <span className="error-text">{errors.address_1}</span>}

        {formData.address_2 ? 
          <label>Landmark</label> 
        :''
        }
        <input 
          name="address_2" 
          placeholder="Landmark" 
          value={formData.address_2 || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
        />

        {formData.city ? 
          <label>City</label> 
        :''
        }
        <DropdownSelect
          label="City"
          name="city"
          options={cities}
          value={formData.city}
          onChange={handleDropdownChange}
          placeholder="Select a city"
          valueKey="city_id"
          labelKey="city_name"
          disabled={formDisabled}
          className={errors.city ? 'focusedColumn' : ''}
        />
        {errors.city && <span className="error-text">{errors.city}</span>}

        {formData.state ? 
          <label>State</label> 
        :''
        }
        <select
          id="stateDropdown"
          name="state"
          value={formData.state || ''}
          onChange={(e) => e.preventDefault()} // prevent manual change
          style={{ pointerEvents: 'none', backgroundColor: '#f5f5f5' }}
          required

        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.state_id} value={state.state_id}>
              {state.state_name}
            </option>
          ))}
        </select>
        {errors.state && <span className="error-text">{errors.state}</span>}

        {formData.pincode ? 
          <label>Pincode</label> 
        :''
        }
        <input 
          name="pincode" 
          placeholder="Pincode*" 
          value={formData.pincode || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
          className={errors.pincode ? 'focusedColumn' : ''}
        />
        {errors.pincode && <span className="error-text">{errors.pincode}</span>}

        <div className='tandc'>

          <input
            type="checkbox"
            name="tandc"
            checked={formData?.tandc || false}
            className={errors.tandc ? 'check-focused' : ''}
            onChange={handleCheckBoxChange}
          />

          <span className='tandc-text'>I hereby accept the <a href="https://gaadibazaar.co.in/user-agreement" target="_self" rel="noopener noreferrer" onClick={(e) => { e.preventDefault(); window.open('https://gaadibazaar.co.in/user-agreement', '_self', 'noopener,noreferrer'); }}>Terms & Conditions</a>
          </span>
          
          {errors.tandc && <span className="error-text">{errors.tandc}</span>}
        </div>
          

        <button
          type="button"
          className='save-continue'
          onClick={handleSubmit}
        >
          {submitLoading || vehicleNumberloading || loader ? (
              <Spinner />
            ) : 
            (
            <>
              {'Save & Continue'}
              <img 
                src={`${process.env.PUBLIC_URL}/assets/proceed_arrow.svg`} 
                alt="Save" 
                className="proceed-arrow" 
              />
           </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ProfileForm;
